import "./style.scss";

import Button from "shared/ui/Button";
import { Button_Style } from "shared/ui/Button/Button";
import Checkbox from "shared/ui/Checkbox";
import { FC, useContext, useState } from "react";
import TextArea from "shared/ui/TextArea";
import { createAccompaniment } from "features/accompaniment";
import { UserContext } from "features/account";
import { isBasicAccompanimentOffer } from "shared/config/pricings";

interface IDAssistantCommentProps {
    steps: any;
    setDatas: (data: any) => void;
    datas: any;
    handlePreviousStep: () => void;
    handleNextStep: () => void;
    handlePageResult: (title: string, message: string, paymentSucceeded: boolean) => void;
    withUploadedDocument?: boolean;
}
const IDAssistantComment: FC<IDAssistantCommentProps> = ({
     steps, setDatas, handleNextStep, handlePreviousStep, datas,
      withUploadedDocument = false,
     handlePageResult
}) => {

  const { userType } = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(false);

  const handleCreateAccompaniment = async () => {
    setIsLoading(true);
    let nextTitle = ` annulée`;
    let message = `L'accompangnemrnt' a été annulé`;
    let isOK = false;

    const data: any = {
      type: userType ?? 'individual',
      documents_ids: datas?.documents_ids,
      adresse: datas?.addresse,
      city: datas?.city,
      postalCode: datas?.postalCode,
      comment: datas?.comment,
      filesToUpload: datas?.filesToUpload, // si il choisi le doc depuis IDTracker
      docNumber: datas.docNumber,
      docCodeCountry: datas.docCodeCountry,
      typeDoc: datas.typeDoc,
      raisons: datas.raisons,
      plaintesRaisons: datas.plaintesRaisons,
      docsToUpload: datas.docsToUpload,
      birthPlace: datas.birthPlace,
      birthDate: datas.birthDate,
      ownerOfThisDoc: datas.ownerOfThisDoc,
      sex: datas.sex,
      dateDepotPlainte: datas.dateDepotPlainte,
      chosenPlan: datas.chosenPlan,
      alreadyPaidFromWordpress: true,
    };
    try {
      await createAccompaniment(data);
      nextTitle = `Dossier enregistré`;
      if (!isBasicAccompanimentOffer(datas.chosenPlan.offreId)) { // Offre Premium
        message = `Vos informations ont été reçues par l’équipe ID Protect, qui va désormais entamer la rédaction de votre courrier.`;
      } else { // Offre Basic
        message = `Vos courriers ont été rédigés et ajoutés à votre dossier d’accompagnement.`;
      }
      isOK = true;
    } catch (e: any) {
    } finally {
      handlePageResult(nextTitle, message, isOK);
    }
  }
    return (
        <div className="IDAssistantComment w-100 h-100 d-flex flex-column align-items-center justify-content-between">
            <div>
                <h3>Circonstances</h3>
                <p>
                  Veuillez nous indiquer les circonstances qui vous ont amené à souscrire à la plateforme ID Protect.
                </p>
                <TextArea
                  rows={8}
                  cols={50}
                  className={"w-100"}
                    placeholder=""
                    onChange={(e) => setDatas({ ...datas, comment: e.target.value })}
                  value={datas.comment}
                />
            </div>
            <div className={`d-flex justify-content-${!steps[0].isCurrent ? "between" : "end"} w-100`}>
                {!steps[0].isCurrent && (
                    <Button
                        label={"Retour"}
                        onClick={() => handlePreviousStep()}
                        style={Button_Style.OUTLINED}
                    />
                )}
                {!withUploadedDocument ? (
                  <Button
                    label={"Suivant"}
                    onClick={() => handleNextStep()}
                  />
                ) : (
                  <Button
                    label={"Sauvegarder"}
                    onClick={handleCreateAccompaniment}
                    isLoader={isLoading}
                  />
                )}
            </div>
        </div>
    );
};

export default IDAssistantComment;
